var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPipelineRestoreVersion = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.013 12.89V8.446h1.294v3.777l3.018 1.849-.62 1.075z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.824 6.275c.7.4 1.314.931 1.825 1.575a.2.2 0 0 0 .036.033c.38.484.694 1.026.928 1.61a6.74 6.74 0 0 1 .21 4.41 6.54 6.54 0 0 1-2.552 3.547 6.2 6.2 0 0 1-4.156 1.073 6.28 6.28 0 0 1-3.874-1.888l-.991 1.022a7.67 7.67 0 0 0 4.727 2.305 7.6 7.6 0 0 0 5.073-1.31 8 8 0 0 0 3.116-4.33 8.23 8.23 0 0 0-.257-5.382 7.92 7.92 0 0 0-3.512-3.994 7.6 7.6 0 0 0-2.135-.788 7.57 7.57 0 0 0-6.31 1.537C5.996 7.271 4.973 9.621 4.973 12H3.647c-.123-.003-.192.145-.116.245l2.07 2.706a.146.146 0 0 0 .232 0l2.07-2.706a.155.155 0 0 0-.039-.224.14.14 0 0 0-.079-.023H6.38c0-1.514.51-2.982 1.443-4.154a6.33 6.33 0 0 1 3.675-2.27 6.18 6.18 0 0 1 4.327.702Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPipelineRestoreVersion);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pipeline-restore-version.e39ddf34.svg";